import { createActions, createReducer } from 'reduxsauce'

import PlanoEstrategicoIndicadoresService from '../servicos/PlanoEstrategicoIndicadoresService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaPlanoEstrategicoInicio: [],
    buscaPlanoEstrategicoSucesso: ['planoEstrategico'],
    buscaPlanoEstrategicoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaPlanoEstrategico = () => {
    return dispatch => {
        dispatch(Creators.buscaPlanoEstrategicoInicio())
        let serv = new PlanoEstrategicoIndicadoresService()
        return serv
            .getPlanoEstrategico()
            .then(response => dispatch(Creators.buscaPlanoEstrategicoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaPlanoEstrategicoErro(error)))
    }
}

const buscaPlanoEstrategicoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaPlanoEstrategicoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaPlanoEstrategicoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.planoEstrategico, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PLANO_ESTRATEGICO_INICIO]: buscaPlanoEstrategicoInicio,
    [Types.BUSCA_PLANO_ESTRATEGICO_ERRO]: buscaPlanoEstrategicoErro,
    [Types.BUSCA_PLANO_ESTRATEGICO_SUCESSO]: buscaPlanoEstrategicoSucesso,
})
